$(document).ready(($) => {
  const lightboxSettings = {
    closeText: `
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path d="M1 11 11 1M1 1l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
    navText: [
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.33594 11.3359L13.8359 3.875C14.1875 3.48438 14.7734 3.48438 15.1641 3.875C15.5156 4.22656 15.5156 4.8125 15.1641 5.16406L8.28906 12L15.125 18.875C15.5156 19.2266 15.5156 19.8125 15.125 20.1641C14.7734 20.5547 14.1875 20.5547 13.8359 20.1641L6.33594 12.6641C5.94531 12.3125 5.94531 11.7266 6.33594 11.3359Z" fill="currentColor"/>
  </svg>
  `,
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.6641 11.3359C18.0156 11.7266 18.0156 12.3125 17.6641 12.6641L10.1641 20.1641C9.77344 20.5547 9.1875 20.5547 8.83594 20.1641C8.44531 19.8125 8.44531 19.2266 8.83594 18.875L15.6719 12.0391L8.83594 5.16406C8.44531 4.8125 8.44531 4.22656 8.83594 3.875C9.1875 3.48438 9.77344 3.48438 10.125 3.875L17.6641 11.3359Z" fill="currentColor"/>
  </svg>
  `,
    ],
  };

  const $isArticle = $('.js-article');
  if ($isArticle.length > 0) {
    const $images = $isArticle.find('img');

    $images.each(function () {
      if ($(this).parents('.c-buytip').length > 0) {
        return;
      }
      if ($(this).parents('.c-form-segmentation').length > 0) {
        return;
      }

      const $src = $(this).attr('src');

      if ($(this).parents('a').length < 1) {
        $(this).wrap(`<a href="${$src}" class="js-lightbox" />`);
      }
    });

    const $galleries = $('.js-gallery');
    $galleries.each(function () {
      $(this).find('.js-lightbox').simpleLightbox(lightboxSettings);
    });
  }
});
